import { useTranslation } from "react-i18next";
import { PointIcon } from "~/features/cart/point-icon.component";
import { TopPharmacyBackgroundIcon } from "~/features/cart/top-pharmacy-background-icon.component";

export function ProductDetailsVendorSelectInfoCard() {
	const { t } = useTranslation("product");

	return (
		<div className="relative w-full md:w-[240px] md:h-[300px] rounded-xl overflow-hidden bg-ansay-900">
			<div className="absolute bottom-0 right-0">
				<TopPharmacyBackgroundIcon />
			</div>
			<div className="relative z-10 p-5 md:p-6 h-full flex flex-col text-gray-100 text-body">
				<h3 className="mb-4">
					<span className="text-body-bold">
						{t("vendor.pdp.topPharmacies")}
					</span>{" "}
					{t("vendor.pdp.topPharmaciesDisclaimerTitle")}
				</h3>
				<div className="flex flex-col gap-3">
					<div className="flex items-start gap-2">
						<div className="flex-shrink-0 w-5 h-5 mt-0.5">
							<PointIcon className="w-full h-full" />
						</div>
						<span>{t("vendor.pdp.topPharmaciesDisclaimerService")}</span>
					</div>
					<div className="flex items-start gap-2">
						<div className="flex-shrink-0 w-5 h-5 mt-0.5">
							<PointIcon className="w-full h-full" />
						</div>
						<span>{t("vendor.pdp.topPharmaciesDisclaimerThree")}</span>
					</div>
					<div className="flex items-start gap-2">
						<div className="flex-shrink-0 w-5 h-5 mt-0.5">
							<PointIcon className="w-full h-full" />
						</div>
						<span>{t("vendor.pdp.topPharmaciesDisclaimerEasyPayment")}</span>
					</div>
					<div className="flex items-start gap-2">
						<div className="flex-shrink-0 w-5 h-5 mt-0.5">
							<PointIcon className="w-full h-full" />
						</div>
						<span>{t("vendor.pdp.topPharmaciesDisclaimerFastDelivery")}</span>
					</div>
				</div>
			</div>
		</div>
	);
}
